export enum VasEntryPoint {
  PromoteListings = 'promote_listings',
  PromotedClosets = 'promoted_closets',
  ProfilePromotedClosets = 'profile_promoted_closets',
  PromotedClosetsStats = 'promoted_closets_stats',
  PushUps = 'push_ups',
  NewMemberBumpOnboarding = 'new_member_bump_onboarding',
}

export enum VasImages {
  VasBump = 'vas-bump',
  VasClosetPromo = 'vas-closet-promo',
  VasClosetPromoStats = 'vas-closet-promo-stats',
}
